var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","nudge-bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({attrs:{"color":_vm.tcColor}},'v-icon',attrs,false),on),[_vm._v(_vm._s(_vm.tcIcon))])]}}])},[_c('i18n',{attrs:{"path":'testcode.'+_vm.tc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }